'use strict';

try {
    module.exports = window.localStorage || window.sessionStorage;
} catch (e) {
    module.exports = null;
}
//# sourceMappingURL=storage.js.map